import { useEffect, useMemo } from "react";
import * as anchor from "@project-serum/anchor";

import { useDispatch } from "react-redux";
import Home from "./Home";
import { setSolanaConfig } from "./redux/actions/common";


const candyMachineId = new anchor.web3.PublicKey(
  process.env.REACT_APP_CANDY_MACHINE_ID!
);

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost);

const txTimeout = 30000; // milliseconds (confirm this works for your project)


const AppContainer = () => {
  // Custom RPC endpoint.
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setSolanaConfig({
      candyMachineId,
      connection,
      txTimeout,
      rpcHost
    }))
  }, [dispatch])


  return (
    <Home
      candyMachineId={candyMachineId}
      connection={connection}
      txTimeout={txTimeout}
      rpcHost={rpcHost}
    />
  );
};

export default AppContainer;
